import { Grid, GridItem } from '@imported/constellation';
import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AllowPermissionCameraForm, PageHeading, } from '../../components/index.js';
import NeedHelp from '../../components/NeedHelp/index.js';
import { useIdvProvider } from '../../context/index.js';
import { useLabelContext } from '../../context/LabelContext.js';
import { DocType } from '../../types/identityContextTypes.js';
import { ROUTE_PATHS } from '../../utils/routePaths.js';
const AllowPermissionCamera = () => {
    const { idvState } = useIdvProvider();
    const { docType } = idvState;
    const { getLabelFromContext } = useLabelContext();
    const navigate = useNavigate();
    const handleAllowPermissionSubmission = useCallback(() => {
        if (docType === DocType.SELFIE) {
            navigate(`../${ROUTE_PATHS.SELFIE_PHOTO}`);
        }
        else {
            navigate(`../${ROUTE_PATHS.SCAN_DOCUMENT}/${idvState.identityState.documentOption}`);
        }
    }, [docType, navigate, idvState.identityState.documentOption]);
    const handleSkip = useCallback(() => {
        navigate(`../${ROUTE_PATHS.TAKE_PHOTO_CONTENT}`);
    }, [navigate]);
    useEffect(() => {
        if (idvState.identityState.documentOption === '') {
            navigate(`../${ROUTE_PATHS.PROOF_OF_IDENTITY}`);
        }
    }, [navigate, idvState.identityState.documentOption]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageHeading, { journeyTitle: idvState.labels.applicationHeading, pageTitle: getLabelFromContext('containers.allowPermission.pageTitle') }),
        React.createElement(Grid, null,
            React.createElement(GridItem, { md: 8, sm: 12 },
                React.createElement(AllowPermissionCameraForm, { handleAllowPermissionSubmission: handleAllowPermissionSubmission, handlePreviousPage: handleSkip })),
            React.createElement(GridItem, { md: 4, sm: 12 },
                React.createElement(NeedHelp, null)))));
};
export default AllowPermissionCamera;
//# sourceMappingURL=index.js.map